/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    // The home route is added to client.js to make sure shared components are
    // added to client.js as well and not repeated in each individual route chunk.
    {
      path: '/schools',
      load: () => import(/* webpackMode: 'eager' */ './schools-splash'),
    },
    {
      path: '/schools/kindergarten',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/kindergarten/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/high-school',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/high-school/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/summer-rising',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/summer-rising/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/district-75',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/district-75/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/middle-school',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/middle-school/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/pre-k',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/pre-k/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/2-k',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/2-k/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/3k',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/3k/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/gt-app',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/gt-app/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/schools/early-learn',
      load: () => import(/* webpackMode: 'eager' */ './home'),
    },
    {
      path: '/schools/early-learn/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    {
      path: '/dashboard/(.*)/schools/:dbn',
      load: () => import(/* webpackMode: 'eager' */ './school-detail'),
    },
    // School finder , logged in
    {
      path: '/dashboard/(.*)/schools',
      load: () => import(/* webpackMode: 'eager' */ './logged-in'),
    },
    // Saves page
    {
      path: '/dashboard/(.*)/saves',
      load: () => import(/* webpackMode: 'eager' */ './saves'),
    },
    // Schedule page
    {
      path: '/dashboard/(.*)/schedule',
      load: () => import(/* webpackMode: 'eager' */ './schedule'),
    },
    {
      path: '/dashboard/(.*)/apply',
      load: () => import(/* webpackMode: 'eager' */ './apply'),
    },
    {
      path: '/dashboard/(.*)/shsat/results',
      load: () => import(/* webpackMode: 'eager' */ './shsat'),
    },
    {
      path: '/dashboard/(.*)/waitlists',
      load: () => import(/* webpackMode: 'eager' */ './waitlist'),
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();
    // Provide default values for title, description etc.
    route.title = route.title
      ? `${route.title} :: Student Enrollment Management System`
      : 'Student Enrollment Management System';
    route.description = route.description || '';
    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
